import { useEffect } from 'react';
import useLogout from './useLogout';
import { SecureStorage } from '../Utilities/StorageEncryption';
const useAutoLogout = () => {
    const { handleLogout } = useLogout();
    useEffect(() => {
        const checkAutoLogout = () => {
            const tokenKey = SecureStorage.getItem('tokenKey');
            if (tokenKey) {
                const { timestamp } = JSON.parse(tokenKey);

                const currentTime = new Date().getTime();
                const timeDifference = currentTime - timestamp;

                const validMinutesInMilliseconds = 60 * 60 * 1000;//move 60 minutes to env

                if (timeDifference > validMinutesInMilliseconds) {
                    handleLogout();
                }
            }
        };

        // Event listener for mouse click
        const onMouseClick = () => checkAutoLogout();
        document.addEventListener('click', onMouseClick);

        // Event listener for keyboard key press
        const onKeyPress = () => checkAutoLogout();
        document.addEventListener('keypress', onKeyPress);

        // Clean up the event listeners on component unmount
        return () => {
            document.removeEventListener('click', onMouseClick);
            document.removeEventListener('keypress', onKeyPress);
        };
    }, []);
};

export default useAutoLogout;
